var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visible ? _c('div', {
    staticClass: "pro_tree_icon",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onChange.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined chev-icon",
    class: {
      'chev-expanded': _vm.expand
    }
  }, [_vm._v("chevron_right")])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };